import {
  ADD_FILEUPLOAD_START,
  ADD_FILEUPLOAD_SUCCESS,
  ADD_FILEUPLOAD_FAILURE,
  ADD_FILEUPLOAD_RESET,
  ADD_CUSTFILEUPLOAD_START,
  ADD_CUSTFILEUPLOAD_SUCCESS,
  ADD_CUSTFILEUPLOAD_FAILURE,
  ADD_CUSTFILEUPLOAD_RESET,
  ADD_POLICYFILEUPLOAD_START,
  ADD_POLICYFILEUPLOAD_SUCCESS,
  ADD_POLICYFILEUPLOAD_FAILURE,
  ADD_POLICYFILEUPLOAD_RESET,
  GET_LEADS_BULKUPLOADS,
  GET_LEADS_BULKUPLOADS_SUCCESS,
  GET_LEADS_BULKUPLOADS_FAILED,
  REVERT_BULK_UPLOAD,
  REVERT_BULK_UPLOAD_FAILED,
  REVERT_BULK_UPLOAD_SUCCESS,
  GET_CUST_BULKUPLOAD_FAILED,
  GET_CUST_BULKUPLOAD,
  GET_CUST_BULKUPLOAD_SUCCESS,
  GET_POLICY_BULKUPLOAD,
  GET_POLICY_BULKUPLOAD_SUCCESS,
  GET_POLICY_BULKUPLOAD_FAILED,
  GET_LIFE_BULKPOLICIES_FAILED,
  GET_LIFE_BULKPOLICIES,
  GET_LIFE_BULKPOLICIES_SUCCESS,
  ADD_MUTUALFUNDFILEUPLOAD_START,
  ADD_MUTUALFUNDFILEUPLOAD_SUCCESS,
  ADD_MUTUALFUNDFILEUPLOAD_FAILURE,
  ADD_MUTUALFUNDFILEUPLOAD_RESET,
  REVERT_MUTUALFUND_BULK_UPLOAD,
  REVERT_MUTUALFUND_BULK_UPLOAD_SUCCESS,
  REVERT_MUTUALFUND_BULK_UPLOAD_FAILED,
  GET_MUTUALFUND_BULKUPLOADS,
  GET_MUTUALFUND_BULKUPLOADS_SUCCESS,
  GET_MUTUALFUND_BULKUPLOADS_FAILED
} from './actiontypes';

const initialState = {
  uploading: false,
  uploaded: false,
  error: null,
  bulkupload: [],
  bulkLeadsList: [],
  bulkCustList: [],
  bulkPoliciesList: [],
  lifeBulkPolicyList: [],
  bulkMutualFundList: [],
  successMsg: ""
};

const fileUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_FILEUPLOAD_START:
      return {
        ...state,
        uploading: true,
        uploaded: false,
        error: null,

      };
    case ADD_FILEUPLOAD_SUCCESS:
      // console.log(action.payload.data)
      return {
        ...state,
        uploading: false,
        uploaded: true,
        error: null,
        bulkupload: action.payload.data,
      };
    case ADD_FILEUPLOAD_FAILURE:
      return {
        ...state,
        uploading: false,
        uploaded: false,
        error: action.payload.message,
      };
    case ADD_FILEUPLOAD_RESET:
      return {
        ...state,
        uploading: false,
        uploaded: false,
        error: null,
        bulkupload: [],
      };


    // custmer bulk upload


    case ADD_CUSTFILEUPLOAD_START:
      return {
        ...state,
        uploading: true,
        uploaded: false,
        error: null,
      };
    case ADD_CUSTFILEUPLOAD_SUCCESS:
      return {
        ...state,
        uploading: false,
        uploaded: true,
        error: null,
        bulkupload: action.payload.data,
      };
    case ADD_CUSTFILEUPLOAD_FAILURE:
      return {
        ...state,
        uploading: false,
        uploaded: false,
        error: action.payload.message,
      };
    case ADD_CUSTFILEUPLOAD_RESET:
      return {
        ...state,
        uploading: false,
        uploaded: false,
        error: null,
        bulkupload: [],
      };

    // custmer Policy upload


    case ADD_MUTUALFUNDFILEUPLOAD_START:
      return {
        ...state,
        uploading: true,
        uploaded: false,
        error: null,
      };
    case ADD_MUTUALFUNDFILEUPLOAD_SUCCESS:
      return {
        ...state,
        uploading: false,
        uploaded: true,
        error: null,
        bulkupload: action.payload.data,
      };
    case ADD_MUTUALFUNDFILEUPLOAD_FAILURE:
      return {
        ...state,
        uploading: false,
        uploaded: false,
        error: action.payload.message,
      };
    case ADD_MUTUALFUNDFILEUPLOAD_RESET:
      return {
        ...state,
        uploading: false,
        uploaded: false,
        error: null,
        bulkupload: [],
      };
    case ADD_POLICYFILEUPLOAD_START:
      return {
        ...state,
        uploading: true,
        uploaded: false,
        error: null,
      };
    case ADD_POLICYFILEUPLOAD_SUCCESS:
      return {
        ...state,
        uploading: false,
        uploaded: true,
        error: null,
        bulkupload: action.payload.data,
      };
    case ADD_POLICYFILEUPLOAD_FAILURE:
      return {
        ...state,
        uploading: false,
        uploaded: false,
        error: action.payload.message,
      };
    case ADD_POLICYFILEUPLOAD_RESET:
      return {
        ...state,
        uploading: false,
        uploaded: false,
        error: null,
        bulkupload: [],
      };

    case GET_LEADS_BULKUPLOADS:
    case GET_CUST_BULKUPLOAD:
    case GET_POLICY_BULKUPLOAD:
    case GET_MUTUALFUND_BULKUPLOADS:
    case REVERT_BULK_UPLOAD:
    case REVERT_MUTUALFUND_BULK_UPLOAD:
    case GET_LIFE_BULKPOLICIES:
      return {
        ...state,
        uploading: true,
        uploaded: false,

      }
    case GET_LEADS_BULKUPLOADS_SUCCESS:
      return {
        ...state,
        uploading: false,
        bulkLeadsList: action.payload,
        successMsg: ""
      }
    case GET_CUST_BULKUPLOAD_SUCCESS:
      return {
        ...state,
        uploading: false,
        bulkCustList: action.payload,
        successMsg: ""
      }

    case GET_MUTUALFUND_BULKUPLOADS_SUCCESS:
      return {
        ...state,
        uploading: false,
        bulkMutualFundList: action.payload,
        successMsg: ""
      }
    case GET_POLICY_BULKUPLOAD_SUCCESS:
      return {
        ...state,
        uploading: false,
        bulkPoliciesList: action.payload,
        successMsg: ""
      }
    case REVERT_MUTUALFUND_BULK_UPLOAD_SUCCESS:
      return {
        ...state,
        successMsg: action.payload,
        uploaded: true,
      }
    case REVERT_BULK_UPLOAD_SUCCESS:
      return {
        ...state,
        successMsg: action.payload,
        uploaded: true,
      }
    case GET_LIFE_BULKPOLICIES_SUCCESS:
      return {
        ...state,
        uploading: false,
        lifeBulkPolicyList: action.payload,
        successMsg: ""
      }
    
    case GET_LEADS_BULKUPLOADS_FAILED:
    case GET_CUST_BULKUPLOAD_FAILED:
    case GET_POLICY_BULKUPLOAD_FAILED:
    case GET_MUTUALFUND_BULKUPLOADS_FAILED:
    case REVERT_BULK_UPLOAD_FAILED:
    case REVERT_MUTUALFUND_BULK_UPLOAD_FAILED:  
    case GET_LIFE_BULKPOLICIES_FAILED:
      return {
        ...state,
        uploading: false,
        error: action.payload
      }

    default:
      return state;
  }
};

export default fileUploadReducer;
